import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const TabsVideos = () => {
  const [tablatures, setTablatures] = useState([]);
  const [tab, setTab] = useState(null);

  const getYouTubeVideoId = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)))?([^"&?\/\s]{11})/);
    return match?.[1] || null;
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/tabs`)
      .then((response) => {
        setTablatures(response.data);
        if (response.data.length > 0) {
          setTab(response.data[0]);
        }
      })
      .catch((error) => {
        console.log('Erreur lors de la récupération des tablatures:');
      });
  }, []);

  return (
    <main>
      <section className="tabs">
        <h1 className="heading">Tablatures</h1>
        <div className="box-container">
          {tablatures.map((tab) => (
            <article key={tab._id} className="box">
              <section className="admin">
                <section className="info">
                  <h3>{tab.login}</h3>
                  <span>{new Date(tab.createdAt).toLocaleDateString()}</span>
                </section>
              </section>
              <section className="thumb">
                <iframe
                  width="330"
                  height="315"
                  src={`https://www.youtube.com/embed/${getYouTubeVideoId(tab.youtubeLink)}`}
                  allowFullScreen
                  title={tab.title}
                ></iframe>
              </section>
              <h3 className="title">{tab.artist} - {tab.title}</h3>
              <NavLink to={`/playlist/${tab._id}`} className="purple-btn">
                En savoir plus...
              </NavLink>
            </article>
          ))}
        </div>
      </section>
    </main>

  );
};

export default TabsVideos;
